<section class="dash-abschnitt" [class.dash-abschnitt--first]="first()">
  <button
    type="button"
    class="dash-abschnitt__kopf"
    [attr.aria-expanded]="offen()"
    [attr.aria-controls]="inhaltId()"
    [attr.data-testid]="'dash-abschnitt-' + abschnittId()"
    (click)="umschalten()"
  >
    <span class="dash-abschnitt__titel">{{ titel() }}</span>
    <span class="dash-abschnitt__linie"></span>
    <span class="dash-abschnitt__umschalten">
      <span class="dash-abschnitt__umschalten-text">
        {{ (offen() ? 'dashAbschnitt.einklappen' : 'dashAbschnitt.aufklappen') | translate }}
      </span>
      <mat-icon class="dash-abschnitt__chevron" [class.dash-abschnitt__chevron--zu]="!offen()" aria-hidden="true">
        chevron_right
      </mat-icon>
    </span>
  </button>
  @if (offen()) {
    <div [id]="inhaltId()">
      <ng-container [ngTemplateOutlet]="inhalt()" />
    </div>
  }
</section>
